
import configData from './config'

export default (Vue) => {
    Object.keys(configData).forEach(item => {
        // 设置vue全局变量
        Vue.prototype[`$${item}`] = configData[item]
    })
}
